import PropTypes from 'prop-types';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import HomepageRolloverBody from './Body';

const View = ({ data, className, editPreview = false }) => (
  <div className={className}>
    <HomepageRolloverBody items={data.items} editPreview={editPreview} />
  </div>
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
  editPreview: PropTypes.bool,
};

export default withBlockExtensions(View);
